import React from 'react'

import Layout from '../components/layout'
import Billboard from '../components/Billboard'
import Seo from '../components/seo'

import gsa from '../images/gsa.png'

const GsaPage = () => (
  <Layout>
    <Seo title="GSA IT70" />

    <Billboard>
      <div className="Billboard__top">
        <h1 className="Billboard__title">GSA IT70</h1>
        <div className="Billboard__lead">
          IT Schedule 70 is an Indefinite Delivery Indefinite Quantity (IDIQ)
          Multiple Award Schedule (MAS) contract.
        </div>

        <div className="Billboard__cta"></div>
      </div>
    </Billboard>

    <section className="section gray pt-3 pt-lg-0 footer-bottom-padding">
      <div className="container">
        <div className="d-flex justify-content-center pb-4">
          <img src={gsa} alt="GSA" />
        </div>
        <p>
          IT Schedule 70 is the largest procurement vehicle and the most widely
          used acquisition offering in the federal government. It offers a
          comprehensive array of IT products, services, and solutions, including
          Innovative IT Solutions, hardware, software, maintenance, network
          services, cyber security, professional IT services, and much more.
          Cloudnexa can provide the following services under the SIN Code 132-51
          (IT Professional Services):
        </p>
        <ul>
          <li>Amazon Web Services (AWS) Solutions & Products</li>
          <li>IT Facility Operation and Maintenance</li>
          <li>IT Systems Development Services</li>
          <li>IT Systems Analysis Services</li>
          <li>Automated Information Systems Design and Integration Services</li>
          <li>Programming Services</li>
          <li>IT Backup and Security Services</li>
          <li>IT Network Management Services</li>
          <li>
            Creation/Retrieval of IT Related Automated News Services, Data
            Services, or
          </li>
          <li>
            Other Information Services (All other information services belong
            under Schedule 76)
          </li>
          <li>
            Other Information Technology Services, Not Elsewhere Classified
          </li>
        </ul>

        <a
          href="https://www.gsaelibrary.gsa.gov/ElibMain/searchResults.do?searchText=GS-35F-0463Y&searchType=allWords&x=0&y=0"
          target="_blank"
          rel="noopener noreferrer"
        >
          View our full GSA schedule
        </a>
      </div>
    </section>
  </Layout>
)

export default GsaPage
